define('pages/main/utilities',["jquery", "appquery", "app"], function($, $$, App) {
    $$ = $$("utilities");

    return {
        init : function(data) {
            var utilityList = $$('#utilityList');
            var utilities = App.global('map_utilities');
            var floor = App.global('map_floor');

            var utilityKeys = Object.keys(utilities)
                .filter(function(u) {
                    var regex = new RegExp('^' + floor + '-');
                    return regex.test(u);
                })
                .map(function(u){
                    return u.replace(floor+ '-', '');
                });

            if(utilityKeys.indexOf('go down') > -1) {
                utilityKeys.removeByValue('go down');
                utilityKeys.unshift('go down');
            }
            if(utilityKeys.indexOf('go up') > -1) {
                utilityKeys.removeByValue('go up');
                utilityKeys.unshift('go up');
            }

            if(!utilityKeys.length) {
                utilityList.after('<p class="text-muted"> No utilities are found on this floor.</p>');
            }

            utilityKeys.forEach(function(utility, index) {
                var appendLineBreak = '';
                if((index+1)%3 == 0) {
                    appendLineBreak = '<br>';
                }
                var imageName = 'icon-' + utility.split(' ').join('_') + '.svg';
                App.database.get(imageName, function(data) {
                    utilityList.append('<li class="btn list-item utility-list inline-block" data-id="' + utility + '"><div class="image-wrapper"><img class="utility-image" src="'+ data +'"/></div>' + utility.split(' ').map(App.utils.capitalize).map(function(name) { if(name.toLowerCase() == 'zopnow') {return "ZopNow"} return name}).join(' ') + '</li>' + appendLineBreak);
                });
            });

            $('#app img').on('error', function() {
                var $that = $(this);
                $that.attr('src', '');
            });

            utilityList.on('click', 'li', function(){
                App.page.render('map', {rack : utilities[floor + '-' + $(this).data('id')], mode : 'multipath'});
            });
        }
    };
});
